module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/store_umeda-3da39e682618be072effe628314962a6.jpg";